import Vue from 'vue';
import Vuex from 'vuex';
import auth from "./auth";
import cart from "./cart";
import product from "./product";
import address from "./address";
import invoice from "./invoice";
import states from "./states";
import order from "./order";
import review from "./review";
import shipmentPrice from "./shipment-price";
import recommendProduct from "./recommend-products";
import payments from "./payments";
import metaTags from "./meta-tags";
import route from "./route";
import delivery from "./delivery";
import suscribe from "./suscribe";
Vue.use(Vuex);
export default function ()
/* { ssrContext } */
{
  var Store = new Vuex.Store({
    modules: {
      auth: auth,
      cart: cart,
      product: product,
      address: address,
      invoice: invoice,
      states: states,
      order: order,
      review: review,
      shipmentPrice: shipmentPrice,
      recommendProduct: recommendProduct,
      payments: payments,
      metaTags: metaTags,
      route: route,
      suscribe: suscribe,
      delivery: delivery
    },
    strict: process.env.DEV
  });
  return Store;
}